import React, { useContext } from 'react';

import PoiCard from 'components/cards/poi/PoiCard';
import Poi from 'models/Poi';
import NewsletterCard from 'components/cards/NewsletterCard';
import Category from 'models/Category';
import ContestSearchResultsCard from 'components/photo-contest/ContestSearchResultsCard';
import AppContext from 'contexts/AppContext';

const SearchResults = ({ pois, category }: { pois: Poi[]; category?: Category }) => {
    const { state } = useContext(AppContext);

    const contestActive = state.photoContest.state === 'ACTIVE';
    return (
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 xl:gap-10 3xl:grid-cols-5 3xl:gap-14">
            {category?.slug === 'nagradni-izbor' && contestActive && <ContestSearchResultsCard />}
            {pois &&
                pois.map((poi, i) => {
                    return (
                        <>
                            {i === 5 && (
                                <div className="justify-self-center w-full" key={poi.id + '' + i}>
                                    <NewsletterCard />
                                </div>
                            )}
                            <div className="justify-self-center flex justify-center w-full" key={poi.id}>
                                <PoiCard
                                    prefetch={false}
                                    images={poi.thumbs}
                                    title={poi.name}
                                    link={`/ideja/${poi.slug}`}
                                    location={`${poi.areas.find((area) => area.type.key === 'municipality')?.name}, ${
                                        poi.areas.find((area) => area.type.key === 'region')?.name
                                    }`}
                                    poiType={poi.type}
                                    attributes={poi.attributes}
                                    category={
                                        category?.slug === 'any' || !category ? poi.type?.default_category : category
                                    }
                                    distance={poi.distance}
                                    photoContest={poi.is_in_contest && contestActive}
                                />
                            </div>
                        </>
                    );
                })}
        </div>
    );
};

export default SearchResults;
